import http from 'hub-http/clients/apiClient';
export const requestDraftSitePagesTotal = () => http.get('cospages/v2/dashboard/site-pages', {
  query: {
    isDraft: true,
    limit: 1
  }
}).then(({
  total
}) => total);